function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5833 12.6667L18.25 9.00008M18.25 9.00008L14.5833 5.33341M18.25 9.00008L5.41667 9.00008M10.9167 12.6667V13.5834C10.9167 15.1022 9.68545 16.3334 8.16667 16.3334H4.5C2.98122 16.3334 1.75 15.1022 1.75 13.5834V4.41675C1.75 2.89796 2.98122 1.66675 4.5 1.66675H8.16667C9.68545 1.66675 10.9167 2.89796 10.9167 4.41675V5.33341",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.af1a28c3.svg";
export { ForwardRef as ReactComponent };